import { motion } from "framer-motion";

export default function Loader() {
  return (
    <motion.div
      data-testid="page-loader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background"
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
    >
      <div className="overflow-hidden">
        <motion.div
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight"
        >
          Agraj <span className="text-primary">Enterprise</span>
        </motion.div>
      </div>
      <p className="mt-3 text-xs uppercase tracking-[0.35em] text-muted-foreground font-display">
        Protective Coating Solutions
      </p>
      <div className="mt-8 h-[3px] w-56 overflow-hidden rounded-full bg-muted">
        <motion.div
          className="h-full bg-primary"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: 1.6, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
}
